const Joi = require("joi")

const validationOptions = {
  abortEarly: false,
  allowUnknown: true,
  stripUnknown: true,
};

// MASTER CREATE FORMS

const warehouse_master = Joi.array().items(
	Joi.object({
		'Warehouse Name': Joi.string().trim().required().max(255),
		'city': Joi.string().trim().required().max(100),
		'location': Joi.string().trim().required().max(255),
		'State': Joi.string().trim().required().max(100),
		'pincode': Joi.alternatives().try(
			Joi.string().trim().required().max(20),
			Joi.number().required()
		),
		'Latitude': Joi.number().allow(null, "").min(-90).max(90).optional(),
		'Longitude': Joi.number().allow(null, "").min(-180).max(180).optional(),
    'Warehouse ID': Joi.number().allow(null, '').allow(null).optional()
	}).required()
).required().max(1000)

const vehicle_registration_master = Joi.array().items(
  Joi.object({
    'Vehicle Type': Joi.string().allow(null, "").optional().max(100),
    'Vehicle Size': Joi.string().required().max(100),
    'Vehicle Capacity (In Ton)': Joi.number().allow(null, "").optional().min(0),
    'Vendor': Joi.string().required().min(1),
    'Vehicle Number': Joi.string().required().max(50),
    'Vehicle RC No.': Joi.string().allow(null, "").optional().max(100),
    'Vehicle Documents': Joi.string().allow(null, "").optional().max(255),
    'Vehicle Condition': Joi.string().allow(null, "").optional().max(100),
    'Vehicle Attached To': Joi.string().allow(null, "").optional().max(100),
    'Vehicle Transaction Type': Joi.string().allow(null, "").valid('LOADING', 'DELIVERY', 'BOOKING').optional(),
    'Last maintenance Date': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ),
    'Next maintenance due date': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ),
    'Vehicle ID': Joi.number().allow(null, '').allow(null).optional()
  }).required()
).required().max(1000)

const gate_master = Joi.array().items(
  Joi.object({
    'Gate ID': Joi.number().allow(null, '').allow(null).optional(),
    'gatename': Joi.string().required().max(100),
    'gatetype': Joi.string().valid("in", "out", "both").required(),
    'OperationalHours': Joi.alternatives().try(
      Joi.string().required().max(100),
      Joi.number().required(),
    ),
    'UsageType': Joi.string().required(),
  }).required()
).required().max(1000)

const dock_master = Joi.array().items(
  Joi.object({
    'Dock ID': Joi.number().allow(null, '').allow(null).optional(),
    'DOCK NAME': Joi.string().required().max(100),
    'DOCK TYPE': Joi.string().valid("in", "out", "both").required(),
    'DOCK NUMBER': Joi.alternatives().try(
      Joi.string().required().max(100),
      Joi.number().required(),
    ),
    'WAREHOUSE': Joi.string().required(),
    'DOCK LOCATION': Joi.string().required().max(255),
    'MAX CAPACITY': Joi.number().allow(null, "").optional(),
    'CURRENT USAGE': Joi.number().allow(null, "").optional(),
  }).required()
).required().max(1000)

const zone_master = Joi.array().items(
  Joi.object({
    'Zone ID': Joi.number().allow(null, '').allow(null).optional(),
    'Zone Name': Joi.string().required().max(100),
    'Zone Type': Joi.string().required().max(50),
    'Zone Number': Joi.alternatives().try(
      Joi.string().required().max(100),
      Joi.number().required(),
    ),
    'Warehouse id': Joi.string().required(),
    'Zone Location': Joi.string().required().max(255),
    'Max Capacity': Joi.number().allow(null, "").optional(),
    'Current Usage': Joi.number().allow(null, "").optional(),
    'Safety Information': Joi.string().allow(null, "").optional(),
  }).required()
).required().max(1000)

const vendor_master = Joi.array().items(
  Joi.object({
    'Vendor ID': Joi.number().allow(null, '').allow(null).optional(),
    'Vendor Name': Joi.string().required().max(255),
    'Contact Person': Joi.string().allow(null, "").optional().max(255),
    'Contact Number': Joi.alternatives().try(
      Joi.string().allow(null, "").optional().max(15),
      Joi.number().allow(null, "").optional(),
    ),
    'Email': Joi.string().allow(null, "").optional().max(100),
    'Address': Joi.string().allow(null, "").optional().max(500),
    'City': Joi.string().allow(null, "").optional().max(100),
    'State': Joi.string().allow(null, "").optional().max(100),
    'Pincode': Joi.alternatives().try(
      Joi.string().allow(null, "").optional().max(15),
      Joi.number().allow(null, "").optional(),
    ),
    'Country': Joi.string().allow(null, "").optional().max(100),
    'Vendor Rating': Joi.number().allow(null, "").optional().max(5).min(0)
  }).required()
).required().max(1000)

const zone_to_dock_mapping = Joi.object({
  dock_id: Joi.number().required().min(1),
  zone_id: Joi.array().items(Joi.number().required()).required(),
}).required()

const map_dock_to_sector = Joi.array().items(
  Joi.object({
    "Sector Name": Joi.string().trim().required(),
    "Dock Name": Joi.string().trim().required(),
  }).required()
).required().max(2000)

const ou_to_sector = Joi.array().items(
  Joi.object({
    "Sector Name": Joi.string().trim().required(),
    "OU": Joi.string().trim().required(),
  }).required()
).required().max(2000)

const shipment_booking_master = Joi.array().items(
  Joi.object({
    'Docket No': Joi.alternatives().try(
      Joi.string().required(),
      Joi.number().required(),
    ).required(),
    'Package No.': Joi.alternatives().try(
      Joi.string().required(),
      Joi.number().required(),
    ).required(),
    'Booking OU': Joi.string().required(),
    'Delivery OU': Joi.string().required(),
    'Shipment Actual Weight': Joi.number().required().min(0),
    'Shipment Volumetric Weight': Joi.number().allow(null, "").optional(),
    'Shipment Dimensions': Joi.string().allow(null, "").optional(),
    'Shipment Category': Joi.string().allow(null, "").optional(),
    'Shipment Subtype': Joi.string().allow(null, "").optional(),
    'Charges': Joi.number().allow(null, "").optional(),
    'Tax': Joi.number().allow(null, "").optional(),
    'Delivery City': Joi.string().allow(null, "").optional(),
    'Delivery Pincode': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.number().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'Delivery State': Joi.string().allow(null, "").optional(),
    'Route Type': Joi.string().allow(null, "").optional(),
    'Shipment Status': Joi.string().allow(null, "").optional(),
    'Shipment Delivery Datetime': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'No of Pkg In Docket': Joi.number().required().min(0),
    'No of Pkg In vehicle': Joi.number().allow(null, "").optional(),
  }).required()
).required().max(2000)

const route_details = Joi.array().items(
  Joi.object({
    'Route No': Joi.alternatives().try(
      Joi.string().required(),
      Joi.number().required(),
    ).required(),
    'Route Path': Joi.string().required().max(255),
    'Schedule departure': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ).allow(null, "").optional(), 
  }).required()
).required().max(2000)

const vehicle_route_controlling = Joi.array().items(
  Joi.object({
    'Veh Reg No': Joi.alternatives().try(
      Joi.string().required(),
      Joi.number().required(),
    ).required(),
    'Contr Ou': Joi.string().required(),
    'Zone': Joi.string().required(),
    'Route No': Joi.alternatives().try(
      Joi.string().required(),
      Joi.number().required(),
    ).required(),
    'Route Status': Joi.string().allow(null, "").optional(),
    'Edc': Joi.string().allow(null, "").optional(),
    'Contr No': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.number().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'Flat Rate': Joi.number().allow(null, "").optional(),
    'Rate/KM': Joi.number().allow(null, "").optional(),
    'Origin': Joi.string().allow(null, "").optional(),
    'Destn': Joi.string().allow(null, "").optional(),
    'Route Catg': Joi.string().allow(null, "").optional(),
    'Veh Make': Joi.string().allow(null, "").optional(),
    'Veh Model': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.number().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'Veh Payload': Joi.number().allow(null, "").optional(),
    'Contract End Date': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'V_L': Joi.number().allow(null, "").optional(),
    'V_B': Joi.number().allow(null, "").optional(),
    'V_H': Joi.number().allow(null, "").optional(),
    'Last Trip No': Joi.string().allow(null, "").optional(),
    'Last trip DATE': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'Mobile No': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.number().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'Email Id': Joi.string().allow(null, "").optional(),
    'Veh Onroad Date': Joi.alternatives().try(
      Joi.string().allow(null, "").optional(),
      Joi.object().allow(null, "").optional(),
    ).allow(null, "").optional(),
    'Age Of Veh': Joi.number().allow(null, "").optional(),
    'Dis': Joi.number().allow(null, "").optional(),
    'R_Type': Joi.string().allow(null, "").optional(),
    'VH_Typ': Joi.string().allow(null, "").optional(),
  }).required()
).required().max(2000)

const scenario = Joi.array()
  .items(
    Joi.object({
      "Scenario Title": Joi.string().required(),
      "Scenario Description": Joi.string().required(),
      "Level Applicable": Joi.number().required(),
    }).required()
  )
  .required();

const stc_contacts = Joi.array()
  .items(
    Joi.object({
      ZONE: Joi.string().required(),
      EDC: Joi.string().required(),
      "EDC Contact Number": Joi.alternatives()
        .try(
          Joi.string()
            .length(10)
            .pattern(/^[0-9]+$/)
            .required(),
          Joi.custom((value, helpers) => {
            const stringValue = String(value);
            if (stringValue.length !== 10 || !/^[0-9]+$/.test(stringValue)) {
              return helpers.error("any.invalid");
            }
            return stringValue;
          })
        )
        .required(),
      STC: Joi.string().required(),
      "STC Manager": Joi.string().required(),
      "STC Contact Number": Joi.alternatives()
        .try(
          Joi.string()
            .length(10)
            .pattern(/^[0-9]+$/)
            .required(),
          Joi.custom((value, helpers) => {
            const stringValue = String(value);
            if (stringValue.length !== 10 || !/^[0-9]+$/.test(stringValue)) {
              return helpers.error("any.invalid");
            }
            return stringValue;
          })
        )
        .required(),
      "Network Manager": Joi.string().required(),
      "Network Contact Number": Joi.alternatives()
        .try(
          Joi.string()
            .length(10)
            .pattern(/^[0-9]+$/)
            .required(),
          Joi.custom((value, helpers) => {
            const stringValue = String(value);
            if (stringValue.length !== 10 || !/^[0-9]+$/.test(stringValue)) {
              return helpers.error("any.invalid");
            }
            return stringValue;
          })
        )
        .required(),
      EDCH: Joi.string().required(),
      "EDCH Contact Number": Joi.alternatives()
        .try(
          Joi.string()
            .length(10)
            .pattern(/^[0-9]+$/)
            .required(),
          Joi.custom((value, helpers) => {
            const stringValue = String(value);
            if (stringValue.length !== 10 || !/^[0-9]+$/.test(stringValue)) {
              return helpers.error("any.invalid");
            }
            return stringValue;
          })
        )
        .required(),
    }).required()
  )
  .required();  


const subscribers = Joi.array().items(
  Joi.object({
    "Contact Name": Joi.string().required(),
    "Contact Number": Joi.alternatives()
      .try(
        Joi.string()
          .length(10)
          .pattern(/^[0-9]+$/)
          .required(),
        Joi.number().min(10)
      )
      .required(),
    Position: Joi.string().allow(null, "").optional(),
  })
);

module.exports = {
	validationOptions,
	warehouse_master,
	vehicle_registration_master,
	gate_master,
	dock_master,
	zone_master,
	vendor_master,
	zone_to_dock_mapping,
  shipment_booking_master,
  route_details,
  vehicle_route_controlling,
  map_dock_to_sector,
  ou_to_sector,
  scenario,
  stc_contacts,
  subscribers
}


